// Need to load bootstrap file in this manner as it's the only way the chunks for module federation load properly.

// Initialize window.nuConfig in the entry chunk so it exists before bootstrap and any early Module Federation
// remote loaders (e.g. Payments / unified components) run — those read nuConfig|NUCONFIG in runtime promise strings.
import "../site-config";

if (window.NUCONFIG) {
    __webpack_public_path__ = (window.NUCONFIG.assetPath || "") + "/"; // eslint-disable-line
}

import("./bootstrap.js");
